import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import { InfoCircleFill, Download } from "react-bootstrap-icons";
import styles from './StatusCheckPage.module.css';
import moment from "moment";
import 'moment/locale/id';
import Header from '../../components/Header/Header';
import * as finalConstant from '../../constants/finalStatus';
import checkStatusLogo from '../../icons/check-status.svg';
import * as apiSupplierOnboard from '../../apis/supplierOnboard';
import { REGISTRATION_STATUS_APPROVED } from "../../constants/registrationStatus";
import { FINAL_STATUS_PENDING, FINAL_STATUS_NEED_REUPLOAD } from "../../constants/finalStatus";

const StatusCheckPage = () => {
    const [registeredSupplierCode, setRegisteredSupplierCode] = useState();
    const [currentStatus, setCurrentStatus] = useState("");
    const [isSupplierOnboardExist, setIsSupplierOnboardExist] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isSupplierApproved, setIsSupplierApproved] = useState(false);
    const [isSupplierNeedReupload, setIsSupplierNeedReupload] = useState(false);
    const [supplierOnboard, setSupplierOnboard] = useState();

    const onSubmitSearch = async () => {
        if (registeredSupplierCode === "") {
            alert("Isi kode registrasi terlebih dahulu");
            return;
        }

        try {
            setIsLoading(true);

            const res = await apiSupplierOnboard.getByRegistrationCode({registrationCode: registeredSupplierCode});
    
            if (res.data) {
                const supplierOnboard = res.data.data;
                setSupplierOnboard(supplierOnboard);
                if (supplierOnboard.registrationStatus === REGISTRATION_STATUS_APPROVED && supplierOnboard.finalStatus === FINAL_STATUS_PENDING) {
                    setIsSupplierApproved(true);
                }
                if (supplierOnboard.finalStatus === FINAL_STATUS_NEED_REUPLOAD) {
                    setIsSupplierNeedReupload(true);
                }
                setCurrentStatus(supplierOnboard.finalStatus);
                setIsSupplierOnboardExist(true);
            } else {
                setIsSupplierOnboardExist(false);
            }
            setIsLoading(false);
        } catch (e) {
            setIsSupplierOnboardExist(false);
            setIsLoading(false);
        }
    }

    const onChangeRegistrationCode = async (e) => {
        setIsSupplierOnboardExist("");
        setRegisteredSupplierCode(e.target.value);
    }

    if (isSupplierApproved || isSupplierNeedReupload) {
        return <Navigate to={'/sample/' + registeredSupplierCode} replace={true} />
    } else {
        return <div className={styles.container}>
            <Header activeKey="/check-status" />
            <div className={styles.pageBody}>
                <Row>
                    <Col lg={12}>
                        <div className={styles.confirmationCard}>
                            <div className={styles.iconArea}>
                                <img src={checkStatusLogo}
                                    alt={"Cek Status"}
                                    className={styles.iconImage}
                                />
                            </div>
                            <Row className='mt-4 justify-content-center'>
                                <h5 className="text-center">Masukkan Kode Registrasi</h5>
                                <div className={styles.searchArea}>
                                    <input className={"form-control"}
                                        placeholder="Masukkan kode registrasi" 
                                        onChange={(e) => {onChangeRegistrationCode(e)}}
                                    />
                                    <Button className={styles.btnRegistration}
                                        onClick={() => onSubmitSearch()}>
                                            Cari
                                    </Button>
                                </div>
                                {isSupplierOnboardExist === false && !isLoading &&
                                    <p className={styles.errorText}>Kode registrasi {registeredSupplierCode} tidak ditemukan.</p>
                                }
                                {isLoading && 
                                    <div>
                                        <Spinner className="mx-auto d-block"
                                    animation="border" size="lg" />
                                    </div>
                                }
                                <div className={styles.messageContainer}>
                                    {isSupplierOnboardExist === true && (currentStatus === finalConstant.FINAL_STATUS_PENDING || currentStatus === finalConstant.FINAL_STATUS_NEED_REVIEW )&&
                                        <div>
                                            <div className={styles.pendingMessageContainer}>
                                                <div className={styles.messageIconArea}>
                                                    <h6><InfoCircleFill className={styles.messageIcon} /></h6>
                                                </div>
                                                <div className={styles.messageTextArea}>
                                                    <h6><strong>Data Anda Sedang Diverifikasi</strong></h6>
                                                    <p className="mb-0">Proses verifikasi data sekitar <b>7 hari kerja</b>. Hasil verifikasi akan diinfokan di halaman Cek Status. Silakan cek kembali secara berkala, ya.</p>
                                                </div>
                                            </div>
                                            {supplierOnboard.samples.length > 0 &&
                                            <div>
                                                <div className={styles.textArea}>
                                                    <p>Selagi tim kami memproses verifikasi dokumen, Anda bisa lakukan pengiriman sampel sesuai dengan data yang sudah diajukan.</p>
                                                    <p className='m-0'>Tanggal Pengiriman Sampel:</p>
                                                    <p>
                                                        <strong>{moment(supplierOnboard.samples.at(-1).deliveryAt).format('dddd, D MMMM YYYY')}</strong>
                                                    </p>
                                                </div>
                                                <div className={styles.textArea}>
                                                    <a target="_blank" href={process.env.REACT_APP_API_URL + "web/supplier-onboard/sample/" + supplierOnboard.samples.at(-1).id + "/sample-document.pdf"}>
                                                        <Button className={styles.btnGreen}>
                                                            <span className="me-2"><Download /></span><span>Download Data Sampel</span>
                                                        </Button>
                                                    </a>
                                                </div>
                                                <div className={styles.infoMessageContainer}>
                                                    <div className={styles.messageIconArea}>
                                                        <InfoCircleFill className={styles.messageIcon} />
                                                    </div>
                                                    <div className={styles.messageArea}>
                                                        <h6>Alamat Warehouse Segari {supplierOnboard.samples.at(-1).warehouse.name}</h6>
                                                        <p className="mb-0">{supplierOnboard.samples.at(-1).warehouse.address}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                            <div className={styles.textArea}>
                                                <p>Jika ada pertanyaan terkait proses registrasi silakan menghubungi kami melalu email <a href="mailto:handoyo@segari.id">handoyo@segari.id</a></p>
                                            </div>
                                        </div>
                                    }
                                    {isSupplierOnboardExist === true && currentStatus === finalConstant.FINAL_STATUS_REJECTED &&
                                        <div className={styles.rejectedMessageContainer}>
                                            <div className={styles.messageIconArea}>
                                                <h6><InfoCircleFill className={styles.messageIcon} /></h6>
                                            </div>
                                            <div className={styles.messageTextArea}>
                                                <h6><strong>Pendaftaran Belum Berhasil</strong></h6>
                                                <p className="mb-0">Mohon maaf, saat ini produk yang Anda tawarkan belum sesuai dengan kebutuhan Segari. Kami akan menghubungi Anda jika nanti ada peluang kerja sama yang cocok dengan produk Anda.</p>
                                            </div>
                                        </div>
                                    }
                                    {isSupplierOnboardExist === true && currentStatus === finalConstant.FINAL_STATUS_SUCCESS &&
                                        <div className={styles.successMessageContainer}>
                                            <div className={styles.messageIconArea}>
                                                <h6><InfoCircleFill className={styles.messageIcon} /></h6>
                                            </div>
                                            <div className={styles.messageTextArea}>
                                                <h6><strong>Anda Memenuhi Syarat Jadi Supplier Segari</strong></h6>
                                                <p className="mb-0">Selamat! Kami senang Anda bergabung menjadi bagian dari layanan Segari. Nantikan info selanjutnya dari tim Segari melalui WhatsApp, ya.</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    }
}

export default StatusCheckPage;